import TreeNodeType from '../../constants/liquidation/TreeNodeType';
import type SensOptions from '../../interfaces/pieces/bordereaux/SensOptions';
import type { TreeRow } from '../../interfaces/pieces/TreeRow';

class LiquidationEmptyResultNotifier {
	private notified = new Set<string>();

	private key(
		entityKey: string,
		state: number | null,
		sens: SensOptions,
	): string {
		return `${entityKey}:${state}:${sens}`;
	}

	markNotified(
		entityKey: string,
		state: number | null,
		sens: SensOptions,
	): void {
		this.notified.add(this.key(entityKey, state, sens));
	}

	/**
	 * Trouve les entités à notifier, les marque comme notifiées,
	 * et retourne true si au moins une notification doit être affichée.
	 */
	notifyEntities(
		filteredData: TreeRow[],
		originalData: TreeRow[],
		expandedKeys: Set<string>,
		state: number | null,
		sens: SensOptions,
	): boolean {
		if (state === null && sens === 'T') return false;

		let hasNewNotifications = false;

		filteredData.forEach((row) => {
			if (row.nodeType !== TreeNodeType.ENTITE) return;
			if (!expandedKeys.has(row.rowKey)) return;
			if (row.children?.length) return;

			const original = originalData.find((r) => r.rowKey === row.rowKey);
			if (!original?.children?.length) return;

			const notificationKey = this.key(row.rowKey, state, sens);
			if (!this.notified.has(notificationKey)) {
				this.notified.add(notificationKey);
				hasNewNotifications = true;
			}
		});

		return hasNewNotifications;
	}

	reset(): void {
		this.notified.clear();
	}
}

export default LiquidationEmptyResultNotifier;
